import { createSlice } from "@reduxjs/toolkit";
import MENU_UI_ACTIONS from "../data/MenuUiActionConstants.js";
const sidebarMenuSlice = createSlice({
  name: 'selected',
  initialState: {
    selected: MENU_UI_ACTIONS.view_dashboard
  },
  reducers: {
    activateMenu: (state, action) => {
      const { selected } = action.payload;
      state.selected = selected;
    }
  }
});
export const { activateMenu } = sidebarMenuSlice.actions;

export default sidebarMenuSlice.reducer;

export const selectSelectedMenu = (state) => {
  return state.ui.sidebar.menu.selected;
}

export const selectedMenuChange = (menuActionName) => {
  return {
    selected: menuActionName
  }
}
